module.exports = __webpack_public_path__ + "static/media/(V)_MG_4877-acessorios.2a616937.jpg";